import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fitpassAPI } from '../services/api';

export const useFitpass = () => {
  const queryClient = useQueryClient();

  // Get all requests
  const { data: allRequests = [], isLoading: isLoadingAll } = useQuery({
    queryKey: ['fitpass', 'all'],
    queryFn: fitpassAPI.getAll,
  });

  // Create request mutation
  const createMutation = useMutation({
    mutationFn: fitpassAPI.create,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fitpass'] });
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }: { id: string; data: any }) =>
      fitpassAPI.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fitpass'] });
    },
  });

  // Update paid status mutation
  const updatePaidMutation = useMutation({
    mutationFn: ({ id, paid }: { id: string; paid: boolean }) =>
      fitpassAPI.updatePaid(id, paid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fitpass'] });
    },
  });

  // Update additional person paid status mutation
  const updateAdditionalPersonPaidMutation = useMutation({
    mutationFn: ({ id, personIndex, paid }: { id: string; personIndex: number; paid: boolean }) =>
      fitpassAPI.updateAdditionalPersonPaid(id, personIndex, paid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fitpass'] });
    },
  });

  // Delete request mutation
  const deleteMutation = useMutation({
    mutationFn: fitpassAPI.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fitpass'] });
    },
  });

  const copyToNextMonthMutation = useMutation({
    mutationFn: fitpassAPI.copyToNextMonth,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fitpass'] });
    },
  });

  return {
    allRequests,
    isLoading: isLoadingAll,
    createRequest: createMutation.mutateAsync,
    updateRequest: updateMutation.mutateAsync,
    updatePaid: updatePaidMutation.mutateAsync,
    updateAdditionalPersonPaid: updateAdditionalPersonPaidMutation.mutateAsync,
    deleteRequest: deleteMutation.mutateAsync,
    copyToNextMonth: copyToNextMonthMutation.mutateAsync,
    isCopying: copyToNextMonthMutation.isPending,
    isUpdating: updateMutation.isPending,
  };
};

